export default {"src":"/_next/static/media/smart.20cc30b8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};